// extracted by mini-css-extract-plugin
export default {"Wrapper":"AccreditationDocumentsImportPopover_Wrapper__6X0Ue","NoImports":"AccreditationDocumentsImportPopover_NoImports__g85zC"};